import { create } from 'zustand';
import { AccountApi, ApiUtils, type RequestEntity, RequestStrategyEnum } from '@shared/api';

interface UseCreditLimitRequestsStore {
  loading: boolean;
  data: RequestEntity[] | null;
  error: string | null;
  getCreditLimitRequests: (accountId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCreditLimitRequestsStore = create<UseCreditLimitRequestsStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  getCreditLimitRequests: ApiUtils.wrapperApi(async (accountId, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountApi.getCreditLimitRequests(accountId, signal);
      set({ loading: false, data: result || null });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: null, error: null }),
}));
